export enum IstatSendStatus {
  IstatSendNotSent = 'ISTAT_SEND_STATUS_NOT_SENT',
  IstatSendNotValid = 'ISTAT_SEND_STATUS_NOT_VALID',
  IstatSendStatusCityTax = 'ISTAT_SEND_STATUS_CITY_TAX',
  IstatSendValid = 'ISTAT_SEND_STATUS_VALID',
}
